import { FC } from 'react'
import { NavLink } from 'react-router-dom'
import { useEstoqueHoje } from '../../hooks/estoque'
import { HojeContadores } from '../../types/estoque'
import { AcessosMenu, ItemMenu, abasMobile, itemAtivo, mostrarAbas } from './menu'
import { IconeDoMenu } from './menuIcones'
import { Aba, AbaBadge, AbaIcone, AbaRotulo, Abas } from './styles'
import { useCelular } from './useCelular'

interface AbasProps {
  acessos: AcessosMenu
  caminho: string
}

const BADGE: Record<string, (c: HojeContadores) => number> = {
  '/interno/estoque/fila': (c) =>
    Number(c.pedidosEmAnalise || 0)
    + Number(c.pedidosAguardandoInfo || 0)
    + Number(c.pedidosAprovados || 0)
    + Number(c.pedidosEmSeparacao || 0)
    + Number(c.pedidosEmEspera || 0)
    + Number(c.pedidosProntos || 0),
  '/interno/estoque/remessas': (c) => Number(c.remessasAtrasadas || 0),
}

const Barra: FC<AbasProps & { contadores: HojeContadores | null }> = ({ acessos, caminho, contadores }) => {
  const abas = abasMobile(acessos)
  if (abas.length === 0) return null

  const numero = (item: ItemMenu): number => {
    const conta = BADGE[item.to]
    return contadores && conta ? conta(contadores) : 0
  }

  return (
    <Abas aria-label="Seções do Estoque">
      {abas.map((item) => {
        const ativo = itemAtivo(item, caminho)
        const total = numero(item)
        return (
          <NavLink key={item.to} to={item.to} style={{ textDecoration: 'none', flex: '1 1 0', minWidth: 0 }}>
            <Aba $ativo={ativo} aria-current={ativo ? 'page' : undefined}>
              <AbaIcone>
                <IconeDoMenu nome={item.icone} tamanho={22} />
                {total > 0 && <AbaBadge>{total > 99 ? '99+' : total}</AbaBadge>}
              </AbaIcone>
              <AbaRotulo>{item.rotulo}</AbaRotulo>
            </Aba>
          </NavLink>
        )
      })}
    </Abas>
  )
}

const BarraComContadores: FC<AbasProps> = (props) => {
  const { data } = useEstoqueHoje()
  return <Barra {...props} contadores={data?.contadores ?? null} />
}

/**
 * OP-3619 — o menu lateral no celular.
 *
 * As quatro telas do dia ficam a um toque, com o que espera decisão em cima
 * do ícone; o resto do módulo entra em "Mais". Só aparece nas telas-raiz do
 * Estoque: no detalhe o rodapé é da ação, não da navegação.
 */
export const AbasEstoque: FC<AbasProps> = (props) => {
  const celular = useCelular()
  if (!celular) return null
  if (!mostrarAbas(props.caminho)) return null
  if (props.acessos.estoque) return <BarraComContadores {...props} />
  return <Barra {...props} contadores={null} />
}

export default AbasEstoque
